import { Color } from '@persona-id/design-tokens';
import { AxisInterval } from 'recharts/types/util/types';

import BarAndLineChartWithLegend from 'dashboard/components/BarAndLineChartWithLegend';
import {
  formatChartDateHour,
  formatChartDateLong,
  formatChartDateLongWithDay,
  formatChartDateMonth,
} from 'dashboard/lib/utils/formatters';
import { MetricsInquiryVolumeDatum, MetricsInquiryVolumeOverTime } from 'dashboard/models/metrics';
import { MetricsInquiryVolumeRates } from 'dashboard/views/DashboardInquiryAnalyticsVolumeV2View/InquiryMetrics';

// Ordering matters here. This is the order in which the bars are shown.
interface InquiryComposedChartProps extends Pick<MetricsInquiryVolumeOverTime, 'period' | 'data'> {
  barKeys: Partial<Record<keyof MetricsInquiryVolumeDatum, string>>;
  barsLabel?: string;
  lineKeys: Partial<Record<keyof (MetricsInquiryVolumeDatum & MetricsInquiryVolumeRates), string>>;
  linesLabel?: string;
  lineGroups?: Record<
    string,
    Partial<Record<keyof (MetricsInquiryVolumeDatum & MetricsInquiryVolumeRates), string>>
  >;
  initialFilteredLegendKeys?: string[];
  colors: Color[];
  interval?: AxisInterval;
  xFormatter: (value: any, index: number) => string;
  legendIcons?: Record<string, JSX.Element>;
}

const InquiryComposedChart = ({
  data,
  period,
  // onDeepLink,
  barKeys,
  barsLabel,
  lineKeys,
  linesLabel,
  lineGroups,
  colors,
  xFormatter,
  initialFilteredLegendKeys,
  interval,
  legendIcons = {},
}: InquiryComposedChartProps) => {
  const createTooltipHeader = (label: number) => {
    return period === 'week'
      ? `Week of ${formatChartDateLong(label)}`
      : period === 'month'
        ? formatChartDateMonth(label)
        : period === 'day'
          ? formatChartDateLongWithDay(label)
          : formatChartDateHour(label);
  };

  return (
    <BarAndLineChartWithLegend
      data={data}
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      legendFormatter={(value: any) => {
        return (
          barKeys[value as keyof MetricsInquiryVolumeDatum] ??
          lineKeys[value as keyof (MetricsInquiryVolumeDatum & MetricsInquiryVolumeRates)]
        );
      }}
      // All reasonable, modern browsers should be preserving the ordering of the keys
      barKeys={Object.keys(barKeys)}
      barsLabel={barsLabel}
      lineKeys={Object.keys(lineKeys)}
      linesLabel={linesLabel}
      lineGroups={lineGroups}
      colors={colors}
      xDataKey='created_timestamp'
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      createTooltipHeader={createTooltipHeader}
      xFormatter={xFormatter}
      interval={interval}
      // onDeepLink={onDeepLink}
      initialFilteredLegendKeys={initialFilteredLegendKeys}
      xAxisLabel='Inquiry created date'
      legendIcons={legendIcons}
    />
  );
};

export default InquiryComposedChart;
